import api from "@/api/apiServiceLayer";
import Store from "@/store/index";

export async function hydrateMerchantContext() {
  const response = await api.get("/context/", "api/v1/merchant", {}, "");
  if (!response || response.status !== 200) {
    throw new Error("merchant_context_load_failed");
  }

  const context = response.data || {};
  Store.commit("userConfig/setMerchantContext", context);
  Store.commit("userConfig/setActiveWorkspace", context.active_workspace || "");

  const storeIds = (context.stores || []).map((store) => Number(store.id));
  const selectedStoreId = Number(Store.state.userConfig.selectedStoreId);
  if (!selectedStoreId || !storeIds.includes(selectedStoreId)) {
    Store.commit(
      "userConfig/setSelectedStoreId",
      context.default_store_id || (storeIds[0] || null)
    );
  }

  return context;
}
